<template>
    <ul class="sidebar sidebar--primary scrollbar d-print-none" :class="{ closed: !isSidebarOpen }">
        <li>
            <button class="btn btn-link btn-link--dark sidebar__close" @click="closeSidebar">
                <i class="material-icons">close</i>
            </button>
        </li>
        <li class="sidebar__item sidebar__item--inactive sidebar__item--first" v-if="profile">
            <router-link :to="{name: 'profile'}" class="text-reset">
                <strong>{{ profile.name }}</strong><br>
                <small>View profile</small>
            </router-link>
        </li>
        <li class="sidebar__divider"></li>
        <li class="sidebar__item">
            <router-link :to="{name: 'orders', params: {orderType: 'job'}}">
                <i class="material-icons sidebar__icon">work_outline</i>
                <span class="d-inline-block">Jobs</span>
            </router-link>
        </li>
        <li class="sidebar__item sidebar__item--child">
            <router-link :to="{name: 'orders', params: {orderType: 'treatment'}}">
                Treatments
            </router-link>
        </li>
        <li class="sidebar__item sidebar__item--child">
            <router-link :to="{name: 'orders', params: {orderType: 'delivery'}}">
                Deliveries
            </router-link>
        </li>
        <li class="sidebar__item sidebar__item--child">
            <router-link :to="{name: 'orders', params: {orderType: 'sale'}}">
                Sales
            </router-link>
        </li>
        <li class="sidebar__item">
            <router-link :to="{name: 'orders', params: {orderType: 'purchase'}}">
                <i class="material-icons material-icons-outlined sidebar__icon">receipt_long</i>
                <span class="d-inline-block">Purchase orders</span>
            </router-link>
        </li>
        <li class="sidebar__item">
            <router-link :to="{name: 'orders', params: {orderType: 'transfer'}}">
                <i class="material-icons material-icons-outlined sidebar__icon">local_shipping</i>
                <span class="d-inline-block">Transfers</span>
            </router-link>
        </li>
        <li class="sidebar__item">
            <router-link :to="{name: 'transactions'}">
                <i class="material-icons sidebar__icon">compare_arrows</i>
                <span class="d-inline-block">Transactions</span>
            </router-link>
        </li>
        <li class="sidebar__item sidebar__item--child">
            <router-link :to="{name: 'orders', params: {orderType: 'adjustment'}}">
                Adjustments
            </router-link>
        </li>
        <li class="sidebar__item">
            <router-link :to="{name: 'stock'}">
                <i class="material-icons sidebar__icon">storage</i>
                <span class="d-inline-block">Stock</span>
            </router-link>
        </li>
        <li class="sidebar__item">
            <router-link :to="{name: 'invoices'}">
                <i class="material-icons material-icons-outlined sidebar__icon">receipt</i>
                <span class="d-inline-block">Invoices</span>
            </router-link>
        </li>
        <li class="sidebar__divider"></li>
        <li class="sidebar__item">
            <router-link :to="{name: 'companies'}">
                <i class="material-icons sidebar__icon">business</i>
                <span class="d-inline-block">Companies</span>
            </router-link>
        </li>
        <li class="sidebar__item">
            <router-link :to="{name: 'users', params: { groupCode: 'contact' }}">
                <i class="material-icons sidebar__icon">people_outline</i>
                <span class="d-inline-block">Contacts</span>
            </router-link>
        </li>
        <li class="sidebar__item">
            <router-link :to="{name: 'products', params: {productType: 'service'}}">
                <i class="material-icons sidebar__icon">
                    miscellaneous_services
                </i>
                <span class="d-inline-block">Services</span>
            </router-link>
        </li>
        <li class="sidebar__item">
            <router-link :to="{name: 'products', params: {productType: 'product'}}">
                <i class="material-icons material-icons-outlined sidebar__icon">category</i>
                <span class="d-inline-block">Products</span>
            </router-link>
        </li>
        <li class="sidebar__item">
            <router-link :to="{name: 'product-types'}">
                <i class="material-icons material-icons-outlined sidebar__icon">category</i>
                <span class="d-inline-block">Product types</span>
            </router-link>
        </li>
        <li class="sidebar__item">
            <router-link :to="{name: 'treatment-categories'}">
                <i class="material-icons material-icons-outlined sidebar__icon">science</i>
                <span class="d-inline-block">Treatment categories</span>
            </router-link>
        </li>
        <li class="sidebar__divider"></li>
        <li class="sidebar__item">
            <router-link :to="{name: 'packages'}">
                <i class="material-icons material-icons-outlined sidebar__icon">layers</i>
                <span class="d-inline-block">Packages</span>
            </router-link>
        </li>
        <li class="sidebar__item">
            <router-link :to="{name: 'vessels'}">
                <i class="material-icons material-icons-outlined sidebar__icon">anchor</i>
                <span class="d-inline-block">Vessels</span>
            </router-link>
        </li>
        <li class="sidebar__item">
            <router-link :to="{name: 'warehouses'}">
                <i class="material-icons material-icons-outlined sidebar__icon">store</i>
                <span class="d-inline-block">Warehouses</span>
            </router-link>
        </li>
        <li class="sidebar__item">
            <router-link :to="{name: 'regions'}">
                <i class="material-icons sidebar__icon">public</i>
                <span class="d-inline-block">Regions</span>
            </router-link>
        </li>
        <li class="sidebar__item">
            <router-link :to="{name: 'locations', params: {locationType: 'company'}}">
                <i class="material-icons material-icons-outlined sidebar__icon">location_on</i>
                <span class="d-inline-block">Address book</span>
            </router-link>
        </li>
        <li class="sidebar__item">
            <router-link :to="{name: 'locations', params: {locationType: 'job'}}">
                <i class="material-icons material-icons-outlined sidebar__icon">location_on</i>
                <span class="d-inline-block">Job locations</span>
            </router-link>
        </li>
        <li class="sidebar__divider"></li>
        <li class="sidebar__item">
            <router-link :to="{name: 'currency-rates'}">
                <i class="material-icons material-icons-outlined sidebar__icon">euro</i>
                <span class="d-inline-block">Currency rates</span>
            </router-link>
        </li>
        <li class="sidebar__item">
            <router-link :to="{name: 'users', params: { groupCode: 'admin' }}">
                <i class="material-icons material-icons-outlined sidebar__icon">
                    admin_panel_settings
                </i>
                <span class="d-inline-block">Admins</span>
            </router-link>
        </li>
        <li class="sidebar__item">
            <router-link :to="{name: 'logs'}">
                <i class="material-icons material-icons-outlined sidebar__icon">info</i>
                <span class="d-inline-block">Logs</span>
            </router-link>
        </li>
        <li class="sidebar__item">
            <router-link :to="{name: 'reports'}">
                <i class="material-icons material-icons-outlined sidebar__icon">trending_up</i>
                <span class="d-inline-block">Reports</span>
            </router-link>
        </li>
        <li class="sidebar__item">
            <a href="" @click.prevent="logout">
                <i class="material-icons sidebar__icon">exit_to_app</i>
                Log out
            </a>
        </li>
    </ul>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      isSidebarOpen: (state) => state.sidebar.isSidebarOpen,
      profile: (state) => state.profile.profile,
    }),
    orderType() {
      return this.$route.params.orderType;
    },
    isPurchase() {
      return this.orderType === 'purchase';
    },
    isTransfer() {
      return this.orderType === 'transfer';
    },
  },
  watch: {
    isSidebarOpen() {
      document.body.style.overflow = this.isSidebarOpen ? 'hidden' : '';
    },
  },
  methods: {
    closeSidebar() {
      this.$store.commit('sidebar/isSidebarOpen', false);
    },
    logout() {
      this.$store.dispatch('auth/logout');
    },
    navigateToOrders(type) {
      if (this.$route.params.orderType === type && !this.$route.params.id) {
        return;
      }
      this.$router.push({
        name: 'orders',
        params: { orderType: type },
      });
    },
  },
};
</script>
